import React, { useState, useEffect } from 'react';
import '../../css/onboardingLinkCardSteps.css';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useMobileMediaQuery, useTabletMediaQuery } from '../../utils';
import Heading from '../../components/Heading';
import imgLinkMBOne from '../../assets/img/mb_slider/desktop/mb_desktop_one.png';
import imgLinkMBTwo from '../../assets/img/mb_slider/desktop/mb_desktop_two.png';
import imgLinkMBThree from '../../assets/img/mb_slider/desktop/mb_desktop_three.png';
import imgLinkMBOneMobile from '../../assets/img/mb_slider/mobile/mb_mobile_one.png';
import imgLinkMBTwoMobile from '../../assets/img/mb_slider/mobile/mb_mobile_two.png';
import imgLinkMBThreeMobile from '../../assets/img/mb_slider/mobile/mb_mobile_three.png';
import SliderMB from '../../components/Sliders/SliderMB';
import GifAnim from '../../components/GifAnim';
import { useDispatch, useSelector } from 'react-redux';
import { setClientId } from '../../features/onboardingData/onboardingUserData';
import langTxt from '../../lang/pt.json';

function OnboardingLinkCardStepMB() {

    const [isLoading, setIsLoading] = useState(true);
    const isMobile = useMobileMediaQuery();
    const isTablet = useTabletMediaQuery();
    const isClientId = useSelector((state) => state.onboardingUserData.isClientId);

    useEffect(() => {
        const delay = setTimeout(() => {
        setIsLoading(false); 
        }, 1000); 

        return () => clearTimeout(delay); 
    }, []);

    const mbData = [
        {
          "imgLinkCard": {
            "desktop": imgLinkMBOne,
            "tablet": imgLinkMBOne,
            "mobile": imgLinkMBOneMobile,
          },
          "titleLinkCard": langTxt.linkCardStepMB.part1.title,
          "txtLinkCard": langTxt.linkCardStepMB.part1.desc
        },
        {
          "imgLinkCard": {
            "desktop": imgLinkMBTwo,
            "tablet": imgLinkMBTwo,
            "mobile": imgLinkMBTwoMobile,
          },
          "titleLinkCard": langTxt.linkCardStepMB.part2.title,
          "txtLinkCard": langTxt.linkCardStepMB.part2.desc
        },
        {
          "imgLinkCard": {
            "desktop": imgLinkMBThree,
            "tablet": imgLinkMBThree,
            "mobile": imgLinkMBThreeMobile,
          },
          "titleLinkCard": langTxt.linkCardStepMB.part3.title,
          "txtLinkCard": langTxt.linkCardStepMB.part3.desc
        }
    ]

  return (  
    <>
    <Header/> 
    { isLoading ? 
        <GifAnim />
    :
    <div className={ isTablet ? "mainViewContainerLinckCardStepsMB" : ( isMobile ? 'mainViewContainerLinckCardStepsMBTablet' : 'mainViewContainerLinckCardStepsMBMobile') }>
        <div className={ isTablet ? 'firstTxtViewContainerLinckCardSteps' : ( isMobile ? 'firstTxtViewContainerLinckCardStepsTablet' : 'firstTxtViewContainerLinckCardStepsMobile') }>
            <Heading hasSaldo={false} />
            <div className={ isTablet ? 'secondMainContainerLinckCardStepsMB' : 'secondMainContainerLinckCardStepsMBMobile' }>
                <div className={ isMobile ? 'firstSubMainContainerLinckCardStepsMB' : ( isMobile ? 'firstSubMainContainerLinckCardStepsMBTablet' : 'firstSubMainContainerLinckCardStepsMBMobile') }>
                    <div className='secondTitleViewLinckCardStepsMobile'>
                        <span className={ isTablet ? 'textTitleRegular400LinckCardSteps' : ( isMobile ? 'textTitleRegular400LinckCardSteps' : 'textTitleRegular400LinckCardStepsMobile') }>Associar cartão através do </span>
                        <span className={ isTablet ? 'textTitleBold700LinckCardSteps' : ( isMobile ? 'textTitleRegular400LinckCardSteps' : 'textTitleBold700LinckCardStepsMobile') }>MULTIBANCO</span>
                    </div>
                    <div className={ isMobile ? 'txtSecondTitleViewLinckCardStepsMobile' : 'txtSecondTitleViewLinckCardStepsMBMobile'}>
                        <span className='textSecondTitleViewLinckCardSteps'>O número da sua Carteira Virtual é: </span>
                        <span className='textSecondTitleBoldViewLinckCardSteps'>{isClientId}</span>
                    </div>
                </div>

                {/* Start slider */}
                <SliderMB
                    listRespData={mbData}
                />
                {/* End slider */}

            </div>          
        </div>
    </div>
    }
    <Footer/> 
    </>
  )
}

export default OnboardingLinkCardStepMB;